module.exports = __webpack_public_path__ + "static/media/mi5.af331905.jpg";